import GTMScript from "@/component/Ads/GTMScript";
import { getDataFromSSR } from "@/handlers/client/commonClient";
// import { useWindowSize } from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
// import Head from "next/head";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ShortsList = dynamic(() => import("@/component/Listing/ShortsList"));
// const Pagination = dynamic(() => import("@/component/Pagination"));
const NoData = dynamic(() => import("@/component/NoData"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
// const WebpageSchema = dynamic(() =>
//   import("@/component/SeoTags/WebpageSchema")
// );
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));
import { apstagBidCallback, createApsSlotsRosDesktop, createApsSlotsRosMobile, requestBiddingFromPWT } from "@/utils/ads";

const Shorts = ({ shortsVideoListData = null, isMobileDevice = false }) => {
  const [currentPage, setCurrentPage] = useState(0);
  // const totalPages = shortsVideoListData?.pagination_cap
  //   ? parseInt(shortsVideoListData?.pagination_cap)
  //   : 10;

  const [shortsData, setShortsData] = useState(
    shortsVideoListData?.content ? shortsVideoListData?.content : []
  );
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  // const totalPages = categoryNewsListData?.pagination_cap
  //   ? parseInt(categoryNewsListData?.pagination_cap)
  //   : 10;
  const router = useRouter();
  // const categoryPath = router?.asPath;

  // const handlePageClick = (page) => {
  //   if (currentPage === page) return;
  //   setCurrentPage(page);
  //   let currentPath = router?.asPath?.split("?")[0];
  //   window.location.href = `${currentPath}?page=${page}`;
  // };

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });

  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getShortListing?page=${currentPage}`
    );
    if (fetchedData?.data?.shortsVideoListData?.content?.length > 0) {
      setShortsData([
        ...shortsData,
        ...fetchedData?.data?.shortsVideoListData?.content,
      ]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };
  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  useEffect(() => {
    if (insightView && scrollDirection == "Scrolling Down" && hasMore) {
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, scrollDirection]);

  useEffect(() => {
    currentPage > 0 && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1659434453897-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_MTF_300x250",
              [300, 250],
              "div-gpt-ad-1659434604998-0"
            )
            .addService(googletag.pubads());

          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_BTF_300x250",
              [300, 250],
              "div-gpt-ad-1659435474737-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
              [320, 50],
              "div-gpt-ad-1659435612077-0"
            )
            .addService(googletag.pubads());

          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();

          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          googletag.destroySlots();
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_728x90",
              [728, 90],
              "div-gpt-ad-1659424515060-0"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_ATF_300x250",
              [300, 250],
              "div-gpt-ad-1707804176041-1"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
              [728, 90],
              "div-gpt-ad-1707804176041-2"
            )
            .addService(googletag.pubads());
          googletag
            .defineSlot(
              "/1007232/News_tak_Desktop_ROS_BTF_728x90",
              [728, 90],
              "div-gpt-ad-1659425743360-0"
            )
            .addService(googletag.pubads());
          // googletag.pubads().enableSingleRequest();
          // googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
        });
      }
      apstag?.fetchBids(
        {
          slots:
            window.screen.width < 900
              ? createApsSlotsRosMobile({ mtf2: false, mtf3: false })
              : createApsSlotsRosDesktop({ mtf2: false, mtf3: false }),
          timeout: 2e3,
        },
        apstagBidCallback
      );
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, []);
  // const size = useWindowSize();

  const metaTitle = "Breaking News shorts | NewsTak";
  const metaDesc =
    "Latest News shorts, shorts न्यूज on Politics, Business & more only on NewsTak";
  const metakeywords =
    "Latest News shorts, short videos, shorts न्यूज on Politics, business short videos";

  return (
    <section>
      <HeadTag
        title={metaTitle}
        description={metaDesc}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + "/short-videos"}
        image={`https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`}
      lcpImage={shortsVideoListData?.latest_videos?.[0]?.image}
      keywords={metakeywords}
      />
      <GTMScript />
      <BreadcrumbSchema
        breadcrumbList={[
          {
            title: "शॉर्ट्स",
            canonical_url: "/short-videos",
          },
        ]}
      />
      <ItemsListSchema data={shortsVideoListData?.content} />

      {/* <VDOAdsScript /> */}

      <Breadcrumb
        breadcrumbList={[
          {
            title: "शॉर्ट्स",
            canonical_url: "/short-videos",
            icon: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/world.svg",
          },
        ]}
      />

      <section className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />
        <ShortsList
          title={"शॉर्ट्स"}
          icon="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/world.svg"
          newsListData={shortsData}
          isLCP={true}
          isMobileDevice={isMobileDevice}
          haveH1={true}
        />
        <div
          className="text-sports news-load h-[50px] w-full mb-4"
          ref={insightref}
        >
          {loadingSpinner === true && (
            <div className="flex items-center justify-center">
              <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
            </div>
          )}
        </div>
        {shortsVideoListData?.content?.length === 0 &&
          shortsData?.length === 0 && <NoData message="No Shorts Found" />}

        <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />
        {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </section>
  );
};

export default Shorts;
